import React from 'react';
import { Controller } from 'react-hook-form';
import { MyMTextBox } from '../ui-elements/MyMTextBox';

/**
 * 入力チェック用テキストボックス Component
 */
// 2024.9.16 MyMine Version2.0対応 Modify Start
const ValidatableTextBox = ({ control, maxLength, name, defaultValue, rules, formState, width, height, disabled, onBlur, color, multiline = false, rows, onChange, InputProps, placeholder, ...other }) => {
  // 2024.9.16 MyMine Version2.0対応 Modify End
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ''}
      render={({ field: { ref, ...field } }) =>
        <MyMTextBox {...field}
          error={formState.errors[name] ? true : false}
          helperText={formState.errors[name]?.message}
          inputValue={defaultValue}
          width={width ?? "100%"}
          // 2024.5.8 MyMine Version1.5対応 Add Start
          height={height ?? '100%'}
          // 2024.5.8 MyMine Version1.5対応 Add End
          color={color}
          maxLength={maxLength}
          className="pb-6"
          disabled={disabled}
          onBlur={((e) => {
            field.onBlur(e);
            onBlur && onBlur(e);
          })}
          multiline={multiline}
          rows={rows}
          onChange={((e) => {
            field.onChange(e);
            onChange && onChange(e);
          })}
          InputProps={InputProps}
          // 2024.9.16 MyMine Version2.0対応 Add Start
          placeholder={placeholder}
          // 2024.9.16 MyMine Version2.0対応 Add End
          // 2024.5.8 MyMine Version1.5対応 Add Start
          {...other}
        // 2024.5.8 MyMine Version1.5対応 Add End
        />
      }
      rules={rules}
    />
  );
};
export default ValidatableTextBox;
